import $ from 'jquery';
import formHandler from '../genericForm/_genericForm';
import { trapFocus, releaseFocus } from '../../common/js/modalA11y';
 
const redressalComplaint = {
    methods : {
        validateFields : function(ele){
            const inputs = $(ele).find('.redressal-complaint__group--input');
            inputs.each(function(){
                $(this).on('input', function(){
                    $(this).siblings('.empty-error').addClass('opacity-0');
                    $(this).removeClass('border-red-300');
                    const regex = new RegExp($(this).data('regex'));
                    if ($(this).prop('required') && $(this).val() === '') {
                        $(this).siblings('.empty-error').removeClass('opacity-0');
                        $(this).siblings('.invalid-error').addClass('opacity-0');
                        $(this).addClass('border-red-300');
                    } 
                    else if (regex.test($(this).val())) {
                        $(this).siblings('.invalid-error').addClass('opacity-0');
                        $(this).siblings('.empty-error').addClass('opacity-0');
                        $(this).removeClass('border-red-300');
                    } 
                    else if (!$(this).prop('required') && $(this).val() === '') {
                        $(this).siblings('.empty-error').addClass('opacity-0');
                        $(this).siblings('.invalid-error').addClass('opacity-0');
                        $(this).removeClass('border-red-300');
                    }
                    else {
                        $(this).siblings('.empty-error').addClass('opacity-0');
                        $(this).siblings('.invalid-error').removeClass('opacity-0');
                        $(this).addClass('border-red-300');
                    }
                });
            });
            const consentStatus = $(ele).find('.redressal-complaint__consent--input');
            consentStatus.on('input',function(e){
                $(this).addClass('border-blue-400').removeClass('border-red-300');
                $(this).siblings('.redressal-complaint__consent--error').addClass('opacity-0');
                if($(this).prop('required') && !$(this).is(':checked')){
                    $(this).removeClass('border-blue-400').addClass('border-red-300');
                    $(this).siblings('.redressal-complaint__consent--error').removeClass('opacity-0');
                }
            })
        },
        getFirstWord : function(str) {
            let words = str.split(' ');
            return words[0];
        },
        handleSubmit : function(ele){
            const form = $(ele).find('.redressal-complaint__questions--form');
            $(form).on('submit', async function(e){
                e.preventDefault();
                const feedback = $(this).find('.feedback').find('.redressal-complaint__group--input');
                const complaintId = $(this).find('.caseID').find('.redressal-complaint__group--input');
                let isFormValid = true;
                const consentCheckbox = $(this).find('.redressal-complaint__consent--input'),
                consentError = $(this).find('.redressal-complaint__consent--error');
                if(!complaintId){
                    isFormValid = false;
                }
                const inputs = $(ele).find('.redressal-complaint__group--input');
                inputs.each(function() {
                    if($(this).hasClass('border-red-300')){
                        isFormValid = false;
                        return;
                    }
                    else if ($(this).prop('required') && $(this).val() == '') {
                        $(this).addClass('border-red-300');
                        $(this).siblings('.empty-error').removeClass('opacity-0');
                        isFormValid = false;
                    }
                });
                if(consentCheckbox.prop('required') && !consentCheckbox.is(':checked')){
                    isFormValid = false;
                    consentCheckbox.siblings('.redressal-complaint__consent--checkbox').removeClass('border-blue-400').addClass('border-red-300');
                    consentError.removeClass('opacity-0');
                }
                if(isFormValid){
                    const servletID = $(this).data('servlet-id');
                    redressalComplaint.methods.handleLoader(ele, true);
                    redressalComplaint.methods.handleRequest(form,complaintId,feedback,ele, servletID);
                }
            });
        },
        handleCaseResponseModal : function(response, ele, caseIdInputVal){
            const parentContainer = $(ele);
            const dstResponseContainer = parentContainer.find('.caseId-response');
            const labelDescription = dstResponseContainer.find('.caseId-response__box').find('div');
            labelDescription.find('div.caseId__response').removeClass('d-none');

            const caseIdInput = $(ele).find('.redressal-complaint__group').find('input[name="caseID"]');
            caseIdInput.val("");

            const inputs = $(ele).find('.redressal-complaint__group--input');
            inputs.each(function() {
                $(this).siblings('.empty-error').addClass('opacity-0');
                $(this).siblings('.invalid-error').addClass('opacity-0');
                $(this).removeClass('border-red-300');
            });
            
            $('body').append(dstResponseContainer);
            $(dstResponseContainer).removeClass('d-none').addClass('inside-body-caseId-response');
            $('body').addClass('overflow-hidden');
            trapFocus($(dstResponseContainer));
        },
        closeCaseIdResponse : function(ele){
            var modal = $('body').find('.inside-body-caseId-response');
            if (modal.length) {
                modal.addClass('d-none');
                $('body').removeClass('overflow-hidden');
                $('body').css('overflow', '');
                $(ele).append(modal.removeClass('inside-body-caseId-response').addClass('d-none'));
                releaseFocus();
            }
        },
        handleCaseCloseModal : function(ele){
            const closeIcon = $(ele).find('.caseId-response__close--icon');
            closeIcon.each(function(){
                $(this).on('click', function(){
                    redressalComplaint.methods.closeCaseIdResponse(ele);
                });
            });
            const closeContainer = $(ele).find('.caseId-response__close');
            closeContainer.each(function(){
                 $(this).on('click', function(){
                     redressalComplaint.methods.closeCaseIdResponse(ele);
                 });
            });
        },
        handleErrorResponseModal : function(ele){
            const parentContainer = $(ele);
            const dstResponseContainer = parentContainer.find('.error-response');
            const labelDescription = dstResponseContainer.find('.error-response__box').find('div');
            labelDescription.find('div.error__response').removeClass('d-none');

            const caseIdInput = $(ele).find('.redressal-complaint__group').find('input[name="caseID"]');
            caseIdInput.val("");
            const feedback = $(ele).find('.redressal-complaint__group').find('input[name="feedback"]');
            feedback.val("");

            const inputs = $(ele).find('.redressal-complaint__group--input');
            inputs.each(function() {
                $(this).siblings('.empty-error').addClass('opacity-0');
                $(this).siblings('.invalid-error').addClass('opacity-0');
                $(this).removeClass('border-red-300');
            });
            
            $('body').append(dstResponseContainer);
            $(dstResponseContainer).removeClass('d-none').addClass('inside-body-error-response');
            $('body').addClass('overflow-hidden');
            trapFocus($(dstResponseContainer));
        },
        closeErrorResponse : function(ele){
            var modal = $('body').find('.inside-body-error-response');
            if (modal.length) {
                modal.addClass('d-none');
                $('body').removeClass('overflow-hidden');
                $('body').css('overflow', '');
                $(ele).append(modal.removeClass('inside-body-error-response').addClass('d-none'));
                releaseFocus();
            }
        },
        handleErrorCloseModal : function(ele){
            const closeIcon = $(ele).find('.error-response__close--icon');
            closeIcon.each(function(){
                $(this).on('click', function(){
                    redressalComplaint.methods.closeErrorResponse(ele);
                });
            });
            const closeContainer = $(ele).find('.error-response__close');
            closeContainer.each(function(){
                 $(this).on('click', function(){
                     redressalComplaint.methods.closeErrorResponse(ele);
                 });
            });
        },
        validatedCaseID: function(ele, caseIdInputVal){
            redressalComplaint.methods.handleLoader(ele, true);
            const url = '/bin/chli/trackComplaint';
            let json = {
                'TicketNo' : caseIdInputVal
            }
            json = JSON.stringify(json);
            $.ajax({
                type: "POST",
                url: url,
                data: json,
                contentType: "application/json",
                dataType: "json",
            }).done((response) => {
                if(Object.keys(response).length <= 0){
                    redressalComplaint.methods.handleLoader(ele, false);
                    redressalComplaint.methods.handleCaseResponseModal(response, ele, caseIdInputVal);
                }else{
                    redressalComplaint.methods.handleLoader(ele, false);
                }
            }).catch((error) => {
                console.error(error);
            });
        },
        checkCaseID: function(ele){
            const caseIdInput = $(ele).find('input[name="caseID"]');
        
            function checkAndSendRequest() {
                const caseIdInputVal = caseIdInput.val().trim();
        
                if (caseIdInputVal) {
                    redressalComplaint.methods.validatedCaseID(ele, caseIdInputVal);
                }
            }
        
            caseIdInput.on('blur', checkAndSendRequest);
        },
        handleRequest : function(form,complaintId,feedback,ele, servletID){
            const url = `/bin/chli/redressalComplaint?servletID=${servletID}`;
            let json = {
                'caseId' : complaintId.val(),
                'feedback': feedback ? feedback.val() : ''
            }
            json = JSON.stringify(json);
            $.ajax({
                type: "POST",
                url: url,
                data: json,
                contentType: "application/json",
                dataType: "json",
            }).done((response) => {
                complaintId.val('');
                feedback.val('');
                redressalComplaint.methods.handleLoader(ele, false);
                redressalComplaint.methods.handleResponseModal(response,ele);
            }).catch((error) => {
                console.error(error);
                redressalComplaint.methods.handleLoader(ele, false);
                redressalComplaint.methods.handleErrorResponseModal(ele);
            });
        },
        handleResponseModal : function(response, ele){
            const parentContainer = $(ele);
            const dstResponseContainer = parentContainer.find('.redressal-response');
            const labelDescription = dstResponseContainer.find('.redressal-response__box').find('div');
            labelDescription.find('div.redressal__response').removeClass('d-none');
            $('body').append(dstResponseContainer);
            $(dstResponseContainer).removeClass('d-none').addClass('inside-body-redressal-response');
            $('body').addClass('overflow-hidden');
            trapFocus($(dstResponseContainer));
        },
        handleLoader: function(loaderContainer, isAdd) {
            const parentLoad = $(loaderContainer).find('.spinning-loader');
            
            if (isAdd) {
                const loaderClone = parentLoad.clone();
                $('body').append(loaderClone); // Move the clone to the body
                loaderClone.removeClass('d-none').addClass('inside-body-loader-request');
                $('body').css('overflow', 'hidden'); // Prevent body scrolling
            } else {
                $('body').css('overflow', ''); // Restore body scrolling
                // Remove the loader clone from the body
                $('body').find('.inside-body-loader-request').remove();
            }
        },        
        closeRedressalResponse : function(ele){
            var modal = $('body').find('.inside-body-redressal-response');
            if (modal.length) {
                modal.addClass('d-none');
                $('body').removeClass('overflow-hidden');
                $('body').css('overflow', '');
                $(ele).append(modal.removeClass('inside-body-redressal-response').addClass('d-none'));
                releaseFocus();
            }
        },
        handleCloseModal : function(ele){
            const closeIcon = $(ele).find('.redressal-response__close--icon');
            closeIcon.each(function(){
                $(this).on('click', function(){
                    redressalComplaint.methods.closeRedressalResponse(ele);
                });
            });
            const closeContainer = $(ele).find('.redressal-response__close');
            closeContainer.each(function(){
                 $(this).on('click', function(){
                     redressalComplaint.methods.closeRedressalResponse(ele);
                 });
            });
        },
        init : function(){
            $('.redressal-complaint').each((idx,ele)=>{
                redressalComplaint.methods.validateFields(ele);
                redressalComplaint.methods.handleSubmit(ele);
                redressalComplaint.methods.handleCloseModal(ele);
                redressalComplaint.methods.checkCaseID(ele);
                redressalComplaint.methods.handleCaseCloseModal(ele);
                redressalComplaint.methods.handleErrorCloseModal(ele);

                // Escape key to close any open response modal (WCAG 2.1.2)
                $(document).on('keydown', function(e){
                    if (e.key === 'Escape') {
                        if ($('body').find('.inside-body-redressal-response').not('.d-none').length) {
                            e.preventDefault();
                            redressalComplaint.methods.closeRedressalResponse(ele);
                        } else if ($('body').find('.inside-body-caseId-response').not('.d-none').length) {
                            e.preventDefault();
                            redressalComplaint.methods.closeCaseIdResponse(ele);
                        } else if ($('body').find('.inside-body-error-response').not('.d-none').length) {
                            e.preventDefault();
                            redressalComplaint.methods.closeErrorResponse(ele);
                        }
                    }
                });
            })
        }
    }
}
 
$(()=>{
    if($('.redressal-complaint').length > 0){
        redressalComplaint.methods.init();
    }
})